import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";
import { mwImage } from "../../../lib/common";
import Link from "next/link";
import { useTranslation } from "next-i18next";

const CategoryCustomPosts = (props) => {
    const { t } = useTranslation("common");
    const raw = props?.data;
    const postData = Array.isArray(raw?.nodes)
        ? raw.nodes
        : Array.isArray(raw?.edges)
          ? raw.edges.map((e) => e.node).filter(Boolean)
          : [];
    const selectedSlug = props.selectedBlog?.slug ?? props.selectedBlog?.node?.slug;
    const filteredPosts = postData.filter(
        (node) => node.slug !== selectedSlug
    );

    return (

        <div className={"related-blog"}>
            <div className={"container"}>
                <h2>{t('blog.relatedPosts')}</h2>
                <div className={"d-flex"}>
                    {filteredPosts.map((item) => {
                        let link = item?.slug;
                        if (item?.parentSlug?.parentSlug != null && item?.parentSlug?.parentSlug.length > 0) {
                            link = item?.parentSlug?.parentSlug;
                        }
                        return (
                            <div className={"blog-card"} key={item.slug}>
                                <Link href={`/blog/${link}/`} itemProp="url">
                                    <Image
                                        src={mwImage(item?.featuredImage?.node?.sourceUrl)}
                                        alt={item.title}
                                        width={100}
                                        height={100}
                                        loading="lazy"
                                        unoptimized
                                    />
                                </Link>
                                <Link href={`/blog/${link}/`} itemProp="url">
                                    <h4>{item.title}</h4>
                                </Link>
                                <Link href={`/blog/${link}/`} className={"read-more"}>
                                    {t('blog.cta.readMore')}
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

CategoryCustomPosts.defaultProps = {
    category: "Knowledge",
};

CategoryCustomPosts.propTypes = {
    category: PropTypes.string,
    selectedBlog: PropTypes.any,
    data: PropTypes.any,
};

export default CategoryCustomPosts;